import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<h1>Berkstresser LLC Learning</h1><h2>Providing a quality, personalized education to those who are academically able but otherwise poorly served by the public school system</h2><p> Motivated students, no matter what age or subject, should have their chance at excellence. We can help. </p><p> Berkstresser Learning is a home-based tutoring service with: <ul><li>A holistic approach to education</li><li>A secular worldview</li><li>A passion for teaching students who want to learn</li><li>A passion for learning new things ourselves</li><li>Over 25 years of combined education experience</li><li>Grade levels: K-12 in core subjects. Some college GEs.</li><li>Flexible scheduling</li><li>Virtual tutoring available when the subject and grade level allow</li><li>A relaxed home environment conveniently located near Branson, MO</li></ul></p><h1>Now scheduling for Summer 2024!</h1>", 5)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://www.facebook.com/BerkstresserLLC"
}, "Facebook", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", { href: "tel:417-929-2533" }, "417-929-2533", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:cjberkstresser@gmail.com" }, "cjberkstresser@gmail.com", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h1", null, "Calendar", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullCalendar = _resolveComponent("FullCalendar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createTextVNode(" Visit us on "),
    _hoisted_6,
    _hoisted_7,
    _createTextVNode(" Call or text us at "),
    _hoisted_8,
    _createTextVNode("."),
    _hoisted_9,
    _createTextVNode("If you prefer email, "),
    _hoisted_10,
    _hoisted_11,
    _hoisted_12,
    _createTextVNode(" We are located at:"),
    _hoisted_13,
    _createTextVNode(" 160 Deer Ln."),
    _hoisted_14,
    _createTextVNode(" Kirbyville, MO 65679"),
    _hoisted_15,
    _hoisted_16,
    _createTextVNode(" --just a little east of Branson, MO. "),
    _hoisted_17,
    _createTextVNode(" (All times US Central)"),
    _hoisted_18,
    _createTextVNode("We do not offer online scheduling capability at this time. Please utilize the phone or email above for inquiries."),
    _hoisted_19,
    _hoisted_20,
    _createVNode(_component_FullCalendar, { options: $data.calendarOptions }, null, 8, ["options"])
  ], 64))
}